import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import ContactUsForm from "../../components/contactus/form";
import { contactUs, visGroupLocations } from "../../utilities/contactUsData";
import GlobalBanner from "../../components/banner";
import DefaultPadding from "../../utilities/constants";
import ContactUsBanner from "../../assets/banner/contactUsBanner.jpg";

const ContactUs = () => {
  useEffect(() => {
    document.title = "Contact Us";
    window.scroll({
      top: 0,
      behavior: "instant",
    });
  }, []);

  const ref = useRef(null);

  const locationRef = useRef(null);

  const padding = new DefaultPadding();
  const defaultPaddingX = padding.getDefaultPaddingX();
  const defaultPaddingY = padding.getDefaultPaddingY();

  return (
    <main>
      <GlobalBanner
        bannerImg={ContactUsBanner}
        backgroundGradient={true}
        discription={
          "At Vis Group, we specialize in planning, developing, optimizing, and scaling network services and digital solutions to drive the seamless progress and growth of your business. Our dedicated team of professionals is committed to ensuring the highest quality and reliability of your solutions. Connect with us today to experience the professional expertise that guarantees the success and resilience of your business."
        }
      >
        Get in <span className="text-visOrange">touch</span> with us
      </GlobalBanner>
      <section
        className={`bg-visLightBlue ${defaultPaddingX} ${defaultPaddingY}`}
      >
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="col-span-1 overflow-hidden rounded-sm bg-white p-10 shadow-visBoxShadow lg:col-span-3">
            <ContactUsForm />
          </div>
          <div className="col-span-1 lg:col-span-2">
            <div
              ref={ref}
              className="flex h-full flex-col justify-between gap-10 px-0 lg:px-16"
            >
              {contactUs.map((contact, index) => {
                return (
                  <motion.div
                    // variants={animation}
                    // initial={"hidden"}
                    // animate={isIsView ? "visible" : "hidden"}
                    whileHover={{
                      scale: 1.05,

                      transition: {
                        type: "spring",
                        stiffness: 150,
                        duration: 0.1,
                      },
                    }}
                    custom={index}
                    className="flex h-full flex-col items-center justify-center gap-3 overflow-hidden rounded-sm bg-white p-5 py-5 text-center shadow-visBoxShadow"
                  >
                    <img className="h-8 w-8" src={contact.icon} alt="" />
                    <p className="text-xl font-normal text-visBlue">
                      {contact.title}
                    </p>
                    <p className="text-base font-normal">{contact.desc}</p>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      <section
        className={`${defaultPaddingX} ${defaultPaddingY} space-y-10 bg-visLightBlue`}
      >
        <h1 className="text-center text-2xl font-semibold text-visBlue md:text-36">
          Vis Group Global Locations
        </h1>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
          {visGroupLocations.map((item, index) => {
            return (
              <motion.a
                ref={locationRef}
                href={item.websiteHref}
                target="_blank"
                // variants={locationAnimation}
                // initial={"hidden"}
                // animate={isLocaiontIsView ? 'visible' : 'hidden'}
                whileHover={{
                  scale: 1.05,
                  cursor: "pointer",
                  transition: { type: "spring", stiffness: 150, duration: 0.1 },
                }}
                custom={index}
                className="col-span-1 h-full overflow-hidden rounded-sm bg-visBlue p-9 text-white"
              >
                <h1 className="mb-2 text-22 font-normal">{item.country}</h1>
                <div className="space-y-2">
                  <p className="text-14 font-medium">{item.companyName}</p>
                  <p>{item.address}</p>
                  <p>{item.email}</p>
                </div>
              </motion.a>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default ContactUs;
